/****************************************************
 * Module Name:  sellMemoModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, FormControlLabel, Radio, RadioGroup, FormControl, TextField, Typography, Pagination, Stack, InputAdornment, Tooltip, FormGroup, styled, Switch, Badge, } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Select from "react-select";
import "../../style/modalstyle.css";
import { useEffect } from "react";
import TradingcompanyProxy from "../../utility/proxy/manager/tradingcompanyProxy";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import StoneDetailModal from "../common/stoneDetailModal";
import { FaFileInvoiceDollar, FaFileInvoice } from "react-icons/fa";
import { LoadingButton } from "@mui/lab";
import ExportComponent from "../common/exportComponent";
import logo from '../../images/pansuriya.jpg'
import UtilityProxy from "../../utility/proxy/manager/utilityProxy";
import EditIcon from '@mui/icons-material/Edit';
import { BackupTable } from "@mui/icons-material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Papa from 'papaparse';
import UserProxy from "../../utility/proxy/manager/userProxy";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommonStoneSelection from "../common/commonStoneSelection";
import CheckIcon from '@mui/icons-material/Check';
import BrokerProxy from "../../utility/proxy/manager/brokerProxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import { BiSolidError } from "react-icons/bi";

const typeOptions = [
  { value: "local", label: "Local" },
  { value: "export", label: "Export" },
];

let exportData = {};

let exportComponentData = (data) => {
  exportData = data;
};

const SellMemoModal = ({
  show,
  setShow,
  handleValidation,
  handleInvoice,
  handleProforma,
  handleUpdateProforma,
  handleUpdateProformaToInvoice,
  stoneId,
  customer,
  user,
  memoId,
  proformaButton,
  sourceData,
  stockData,
  loading,
  loadingProformaButton,
  saveloading,
  saveInvoiceLoading,
  openInvoice,
  setOpenInvoice,
}) => {
  const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
  const defaultBroker = { value: -1, label: " - ", brokerid: -1, username: " - " };
  const [company, setCompany] = useState();
  const [companyOptions, setCompanyOptions] = useState();
  const [type, setType] = useState(typeOptions[0]);
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [insurredBy, setInsurredBy] = useState("");
  const [portOfLoading, setPortOfLoading] = useState("");
  const [countryOfFinalDestination, setCountryOfFinalDestination] = useState("");
  const [shippedBy, setShippedBy] = useState("");
  const [portOfDischarge, setPortOfDischarge] = useState("");
  const [terms, setTerms] = useState("");
  const [finalDestination, setFinalDestination] = useState("");
  const [bankThrough, setBankThrough] = useState(false);
  const [stonesLoader, setStonesLoader] = useState(false);
  const [listData, setListData] = useState([]);
  const [defaultlistData, setDefaultListData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [totalCarat, setTotalCarat] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [currency, setCurrency] = useState("USD");
  const [broker, setBroker] = useState(defaultBroker);
  const [lUser, setLUser] = useState(user);
  const [actualAmount, setActualAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [remark, setRemark] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [stoneDetailModalId, setStoneDetailModalId] = useState("");
  const [page, setPage] = React.useState(1);
  const [proformaPaginatedValueId, setProformaPaginatedValueId] = useState([]);

  const [fieldPermission, setFieldPermission] = useState(false);
  const [canEdit, setCanEdit] = useState(true);
  const [date, setDate] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [proformaDate, setProformaDate] = useState("");

  const [totalDiscount, setTotalDiscount] = useState(0);
  const [oldTotalDiscount, setOldTotalDiscount] = useState(0);
  const [newTotalDiscount, setNewTotalDiscount] = useState(0);

  const [avgPricePerCarats, setAvgPricePerCarats] = useState(0);
  const [oldTotalPPC, setOldTotalPPC] = useState(0);
  const [newTotalPPC, setNewTotalPPC] = useState(0);

  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const [oldTotalInvoiceAmount, setOldTotalInvoiceAmount] = useState(0);
  const [newTotalInvoiceAmount, setNewTotalInvoiceAmount] = useState(0);

  const [addLessPercent, setAddLessPercent] = useState(0);
  const [oldAddLessPercent, setOldAddLessPercent] = useState(0);
  const [addLessAmount, setAddLessAmount] = useState(0);
  const [oldAddLessAmount, setOldAddLessAmount] = useState(0);
  const [addToInvoice, setAddToInvoice] = useState(false);

  const [listStoneIds, setListStoneIds] = useState([]);

  const [applyValue, setApplyValue] = useState(0);
  const [applyToAll, setApplyToAll] = useState("");
  const applyToAllOption = [
    { value: 1, label: "Discount" },
    { value: 2, label: "PPC" },
    { value: 3, label: "Total" },
  ]

  const [uploadLoader, setUploadLoader] = useState(false);
  const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
  const [changedData, setChangedData] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  const [flag, setFlag] = useState(false);

  const [invoiceToCompanyOptions, setInvoiceToCompanyOptions] = useState([]);
  const [invoiceTo, setInvoiceTo] = useState();

  const [prevProformaTradingCompany, setPrevProformaTradingCompany] = useState("");
  const [sellButtonDisable, setSellButtonDisable] = useState(false);

  const [disableInvoiceButton, setDisableInvoiceButton] = useState(false);

  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const [disableAllButtons, setDisableAllButtons] = useState(true);
  const [selectionModel, setSelectionModel] = useState([]);
  const [isColumnsHidden, setIsColumnsHidden] = useState(true);

  const [brokerOptions, setBrokerOptions] = useState([]);
  const [userInputValue, setUserInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [invoiceDays, setInvoiceDays] = useState(0);

  const [kyc, setKyc] = useState(null);
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  // eslint-disable-next-line
  const [proforma_Permission, setProforma_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.SALES_PROFORMA
    )
  );

  // eslint-disable-next-line
  const [salePermission, setSalePermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECTSALE
    )
  );

  // eslint-disable-next-line
  const [proformaEdit, setProformaEdit] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.UPDATEINVOICEDATA
    )
  );

  // eslint-disable-next-line
  const [invoicePermission, setInvoicePermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECTINVOICE
    )
  );

  const notPermitted = (Utility.isUpdateAllowed(proformaEdit) || Utility.isAddAllowed(proformaEdit)) ? false : true;

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#2E7D32',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));

  const prepareProformaDetailData = (response) => {
    setType(
      response !== null && response !== undefined && response.export !== null
        ? response.export
          ? typeOptions[1]
          : typeOptions[0]
        : { value: "error", label: "error" }
    );
    setCountryOfOrigin(
      response !== null &&
        response !== undefined &&
        response.countryoforigin !== null
        ? response.countryoforigin
        : ""
    );
    setInsurredBy(
      response !== null && response !== undefined && response.ensuredby !== null
        ? response.ensuredby
        : ""
    );
    setPortOfLoading(
      response !== null &&
        response !== undefined &&
        response.portofloading !== null
        ? response.portofloading
        : ""
    );
    setCountryOfFinalDestination(
      response !== null &&
        response !== undefined &&
        response.countryoffinaldestination !== null
        ? response.countryoffinaldestination
        : ""
    );
    setShippedBy(
      response !== null && response !== undefined && response.shippedby !== null
        ? response.shippedby
        : ""
    );
    setPortOfDischarge(
      response !== null &&
        response !== undefined &&
        response.portofdischarge !== null
        ? response.portofdischarge
        : ""
    );
    setTerms(
      response !== null && response !== undefined && response.terms !== null
        ? response.terms
        : ""
    );
    setInvoiceDays(response !== null && response !== undefined && response.days !== null ? response.days : 0);
    setFinalDestination(
      response !== null &&
        response !== undefined &&
        response.finaldestination !== null
        ? response.finaldestination
        : ""
    );
    setBankThrough(
      response !== null &&
        response !== undefined &&
        response.bankthrough !== null
        ? response.bankthrough
        : ""
    );
    setRemark(
      response !== null && response !== undefined && response.remarks !== null
        ? response.remarks
        : ""
    );
    setCompany(
      response !== null &&
        response !== undefined &&
        response.tradingcompanyid !== null &&
        response.tradingcompanyname !== null
        ? {
          value: response.tradingcompanyid,
          label: response.tradingcompanyname,
          companylocationid: response.companylocationid,
          country: response.country
        }
        : undefined
    );
    setShippingCost(
      response !== null &&
        response !== undefined &&
        response.shippingcost !== null
        ? response.shippingcost
        : ""
    );
    setExchangeRate(
      response !== null &&
        response !== undefined &&
        response.exchangerate !== null
        ? response.exchangerate
        : 1
    );
    setCurrency(
      response !== null &&
        response !== undefined &&
        response.exchangecurrency !== null
        ? response.exchangecurrency
        : "USD"
    );
    setLUser(
      response !== null &&
        response !== undefined &&
        response.userid !== null &&
        response.usercompanyname !== null
        ? response.userid + " | " + response.usercompanyname
        : ""
    );
    setBroker(
      response !== null &&
        response !== undefined &&
        response.brokerid !== null &&
        response.brokercompanyname !== null
        ? { value: response.brokerid, label: response.brokerid + " | " + response.brokercompanyname, brokerid: response.brokerid, username: response.brokercompanyname }
        : defaultBroker
    );

    setInvoiceTo(
      response !== null &&
        response !== undefined &&
        response.invoicecustomerid !== null &&
        response.invoicecustomercompanyname !== null
        ? { label: response.invoicecustomercompanyname, value: response.invoicecustomerid, state: response.invoicecountry }
        : undefined
    )
  };

  useEffect(() => {
    if (company && formattedDate !== "" && listData.length > 0 && (Constants.loggedInUser.usertype === "E" ? invoiceTo : true) && kyc) {
      setDisableAllButtons(false);
    }
  }, [company, invoiceTo, formattedDate, listData, kyc]);

  useEffect(() => {
    if (company && proformaButton) {
      setCountryOfOrigin(!company.country ? "" : company.country);
      setPortOfLoading(!company.country ? "" : company.country);
    }
  }, [company]);

  useEffect(() => {
    let invoiceToCountry = "";
    if (invoiceTo) {
      if (Array.isArray(invoiceTo)) {
        invoiceToCountry = !invoiceTo[0].country ? "" : invoiceTo[0].country;
      } else {
        invoiceToCountry = !invoiceTo.country ? "" : invoiceTo.country;
      }
    }

    if (proformaButton) {
      setFinalDestination(invoiceToCountry);
      setCountryOfFinalDestination(invoiceToCountry);
      setPortOfDischarge(invoiceToCountry);
    }
  }, [invoiceTo]);

  useEffect(() => {

    setApplyToAll(!applyToAll ? applyToAllOption[0] : applyToAll);

    getAllSettingValues();

    getAllCustomerBroker();

    if (stoneId.length === 0 && stockData) {
      let stoneIdList = [];
      stockData.map((data) => stoneIdList.push(data.stoneid));

      setListStoneIds(stoneIdList);
      stoneId = stoneIdList
    }

    setFieldPermission(Constants.loggedInUser.usertype === 'E' ? true : false);

    if (sourceData && !sourceData[0].canedit) {
      setCanEdit(false);
    }

    getAllCompanyData();
    if (Constants.loggedInUser.usertype === "E") {
      getAllInvoiceToCompanyData();
    }

    UtilityProxy.getDate((response) => {
      if (response) {
        const parts = sourceData && sourceData[0].canedit ? Utility.GetFormatedDBDate(sourceData[0].date).split("-") : response.errorMessage.split("-");
        setFormattedDate(`${parts[2]}-${parts[1]}-${parts[0]}`);
        if (sourceData) {
          const proformaParts = Utility.GetFormatedDBDate(sourceData[0].date).split("-");
          setProformaDate(`${proformaParts[2]}-${proformaParts[1]}-${proformaParts[0]}`);
        }
        setDate(canEdit ? response.errorMessage : sourceData[0].date);
      }
    });

    if (sourceData) {
      prepareProformaDetailData(sourceData[0]);
      setProformaPaginatedValueId(sourceData[0].proformaid);
    }

    if (stockData) {
      handleStockData(stockData);
    } else {
      handleSearch(stoneId);
    }
    setFlag(true)
  }, []);

  const getAllCompanyData = () => {
    TradingcompanyProxy.GetAllTradingcompanyMini((response) =>
      setAllCompanyData(response)
    );
  };

  const getAllInvoiceToCompanyData = () => {
    let employeeId = Utility.isReadAllowed(invoicePermission) ? -1 : Constants.loggedInUser.id;
    UserProxy.GetSpecificEmployeesCustomerMini(employeeId, (response) =>
      setInvoiceToCompany(response)
    );
  };

  const setSnackbarState = (show, message, variant) => {
    setShowSnackbar(show);
    setSnackbarMessage(message);
    setSnackbarVariant(variant);
  };

  const getAllCustomerBroker = () => {
    BrokerProxy.getCustomersBrokerMini(customer.value, (response) => {
      if (response) {
        let optionsArray = [];
        response.forEach(iBroker => {
          let options = { value: iBroker.brokerid, label: iBroker.brokerid + " | " + iBroker.companyname, brokerid: iBroker.brokerid, username: iBroker.companyname };
          optionsArray.push(options);
        });
        setBrokerOptions(optionsArray);
      }
    })
  }

  useEffect(() => {
    if (flag) {
      prepareColumns();
    }
  }, [flag]);

  useEffect(() => {
    if (customer) {
      getCustomerKYC(customer.value);
    }
  }, [customer]);

  useEffect(() => {
    if (proformaButton) {
      if (customer) {
        getLatestProformaDetail();
      }
    }
  }, [customer]);

  const getAllSettingValues = () => {
    if (proformaButton) {
      SettingsProxy.GetSettingByName("DEFAULT_INVOICE_DAYS", (response) => {
        if (response) {
          setInvoiceDays(response.settingvalue);
        }
      });
    }
  }

  const getCustomerKYC = (customerId) => {
    UserProxy.GetKycByUserid(customerId, (response) => {
      // we have not written just if(response) because the api returns boolean value
      if (response !== undefined && response !== null) {
        setKyc(response);
        setDisableAllButtons(!response);
      } else {
        setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        setDisableAllButtons(true);
      }
    });
  }

  const getLatestProformaDetail = () => {
    StoneProxy.GetLatestProformaDetail(customer.value, (response) => {
      if (response) {
        if (Constants.loggedInUser.usertype === "B") {
          setBroker({ value: Constants.loggedInUser.id, label: Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname, brokerid: Constants.loggedInUser.id, username: Constants.loggedInUser.companyname });
        } else if (response.brokerCustomer.brokerid === -1) {
          setBroker(defaultBroker)
        } else {
          setBroker({ value: response.brokerCustomer.brokerid, label: response.brokerCustomer.brokerid + " | " + response.brokerCustomer.companyname, brokerid: response.brokerCustomer.brokerid, username: response.brokerCustomer.companyname })
        }

        if (response.tradingcompanyid) {
          setPrevProformaTradingCompany(response.tradingcompanyid);
        }

        if (response.type) {
          setType(!response.type ? typeOptions[0] : typeOptions[1]);
        }
      }
    });
  }

  useEffect(() => {
    if (prevProformaTradingCompany && companyOptions && companyOptions.length > 0) {
      const tradingCompany = companyOptions.find((data) => data.value === prevProformaTradingCompany);
      setCompany(tradingCompany)
    }
  }, [prevProformaTradingCompany, companyOptions]);

  useEffect(() => {
    setPayableAmount(
      ((Number(invoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2)
    );
  }, [currency, invoiceAmount, shippingCost, exchangeRate]);

  const handleUpload = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          let headersFromCSV = Object.keys(result.data[0]);
          const rowData = [...listData];
          let totalInvoice = 0;
          let requiredColumns = ['stoneid'];
          let optionalColumns = ['discount', 'pricepercarat', 'totalprice'];
          let providedColumns = headersFromCSV.filter(field => requiredColumns.concat(optionalColumns).includes(field));
          if (providedColumns.includes('stoneid') && providedColumns.length >= 2) {
            result.data.forEach(record => {
              rowData.forEach(row => {
                let newRow = {};
                if (row.stoneid === parseInt(record.stoneid)) {
                  if (record['discount']) {
                    let discount = parseFloat(record['discount']);
                    let discountprice = parseFloat(((row.originalprice * row.size) * ((100 + discount) / 100)).toFixed(2));
                    let discountpricepercarat = parseFloat((discountprice / row.size).toFixed(2));
                    newRow = {
                      ...row,
                      discount: discount,
                      discountprice: discountprice,
                      discountpricepercarat: discountpricepercarat,
                    };
                  } else if (record['pricepercarat']) {
                    let discountpricepercarat = parseFloat(record['pricepercarat']);
                    let discount = parseFloat(((((discountpricepercarat * row.size) / (row.originalprice * row.size) * 100) - 100).toFixed(2)));
                    let discountprice = parseFloat((discountpricepercarat * row.size).toFixed(2));
                    newRow = {
                      ...row,
                      discountpricepercarat: discountpricepercarat,
                      discount: discount,
                      discountprice: discountprice,
                    }
                  } else if (record['totalprice']) {
                    let discountprice = parseFloat(record['totalprice']);
                    let discount = parseFloat((100 - (discountprice * 100) / (row.originalprice * row.size)).toFixed(2) * -1);
                    let discountpricepercarat = parseFloat(((discountprice / row.size).toFixed(2)));
                    newRow = {
                      ...row,
                      discountprice: discountprice,
                      discount: discount,
                      discountpricepercarat: discountpricepercarat,
                    }
                  }
                  rowData[rowData.findIndex(r => r.stoneid === parseInt(record['stoneid']))] = newRow;
                }
              });
            });
            rowData.forEach(row => {
              totalInvoice += parseFloat(row.discountprice);
              return true;
            });
            setInvoiceAmount(Number(totalInvoice).toFixed(2));
            setAvgPricePerCarats(parseFloat((totalInvoice / totalCarat).toFixed(2)));
            setPayableAmount(((Number(totalInvoice) + Number(shippingCost) + Number(addLessAmount)) * Number(exchangeRate)).toFixed(2));
            setTotalDiscount((100 - (Number(totalInvoice) * 100) / Number(actualAmount)).toFixed(2) * -1);
            setListData([...rowData]);
            setUploadLoader(false);
            setUploadSuccessSnackbar(true);
            setChangedData(true);
          } else {
            console.error('CSV columns do not match required columns (stoneid + any one of discount, discountpricepercarat, discountprice)');
            setChangedData(false);
            setUploadLoader(false);
            setUploadSuccessSnackbar(true);
          }
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
          setChangedData(false);
          setUploadLoader(true);
        }
      });
    };
    reader.readAsText(file);
  };

  const handleClear = () => {
    const fileInput = document.getElementById('file-input');
    fileInput.value = null;
  }

  const handleStockData = (stockData) => {
    setStonesLoader(true);
    let lTotalCarat = 0;
    let lActualPrice = 0;
    let lActualDiscountPrice = 0;
    let newListData = [];
    let lInvoiceAmount = 0;
    let totalValueOfInrMulExchangeRate = 0;
    let totalValueOfInr = 0;
    let onlyUsd = true;
    let addLessAmount = 0;
    let addToInvoice = false;
    let hideColumnFlag = true;

    stockData.map((res) => {
      if (res.exchangecurrency === "INR") {
        totalValueOfInrMulExchangeRate += Number(res.size * res.originalprice * Number(res.exchangerate));
        totalValueOfInr += Number(res.size * res.originalprice);
        onlyUsd = false;
      }
      addLessAmount += res.stoneprice * (res.addlesspercent / 100);
      lTotalCarat += Number(res.size);
      lActualPrice += Number(res.size * res.originalprice);
      let actualPrice = Number(res.originalprice * res.size);
      let tempDiscountPrice = res.stoneprice;
      let listOp = {
        ...res,
        olddiscount: res.discount,
        oldppc: res.discountprice,
        discountprice: tempDiscountPrice,
        olddiscountprice: tempDiscountPrice,
      };
      newListData.push(listOp);
      lInvoiceAmount += Number(actualPrice * ((100 + res.discount) / 100));
      lActualDiscountPrice += tempDiscountPrice;

      if (!addToInvoice) {
        addToInvoice = res.addToInvoice !== null ? res.addToInvoice : false;
      }

      // If stoneoldstatus is not null that means stone is in LOCATION_TRANSFER
      if (res.stoneoldstatus !== null || res.status === "SELL_SENT") {
        setDisableInvoiceButton(true);
        setWarningMessage("Stone is IN_TRANSIT. Please Mark stone as received before placing INVOICE");
      }
      // If Rapnet Price and new Rapnet Price is not same then show New Rap Column
      if (Constants.loggedInUser.usertype === "E" && res.originalprice.toFixed(2) !== res.neworiginalprice.toFixed(2)) {
        hideColumnFlag = false;
      }
      return true;
    });

    let tempInvoiceAmount = lActualDiscountPrice.toFixed(2);
    let tempPricePerAmount = (lActualDiscountPrice / lTotalCarat).toFixed(2);
    let tempDiscount = ((100 - (lActualDiscountPrice * 100) / lActualPrice) * -1).toFixed(2);

    setIsColumnsHidden(hideColumnFlag);
    setTotalDiscount(tempDiscount);
    setOldTotalDiscount(tempDiscount);
    setTotalCarat(lTotalCarat.toFixed(2));
    setActualAmount(lActualPrice.toFixed(2));
    setListData(newListData);
    setDefaultListData(newListData);
    setInvoiceAmount(parseFloat(tempInvoiceAmount));
    setOldTotalInvoiceAmount(tempInvoiceAmount);
    setOldTotalPPC(parseFloat(tempPricePerAmount));
    setAvgPricePerCarats(parseFloat(tempPricePerAmount));
    setNewTotalDiscount(tempDiscount);
    setNewTotalPPC(parseFloat(tempPricePerAmount));
    setNewTotalInvoiceAmount(tempInvoiceAmount);
    if (!onlyUsd) {
      setExchangeRate((totalValueOfInrMulExchangeRate / totalValueOfInr).toFixed(2));
    }
    setPayableAmount(((Number(lInvoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2));
    setAddLessAmount(Number(addLessAmount).toFixed(2));
    setAddLessPercent(Number((addLessAmount / parseFloat(lInvoiceAmount.toFixed(2))) * 100).toFixed(2));
    setOldAddLessAmount(0);
    setOldAddLessPercent(0);
    setAddToInvoice(addToInvoice);
    setApplyValue(0);
    setStonesLoader(false);
  }

  const handleSearch = (stoneId) => {
    setStonesLoader(true);
    StoneProxy.GetMultipleStone(customer.value, stoneId, (response) => {
      let lTotalCarat = 0;
      let lActualPrice = 0;
      let lActualDiscountPrice = 0;
      let newListData = [];
      let lInvoiceAmount = 0;
      let hideColumnFlag = true;

      response.map((res) => {
        lTotalCarat += Number(res.size);
        lActualPrice += Number(res.size * res.originalprice);
        lActualDiscountPrice += Number(res.stoneprice);
        let actualPrice = Number(res.originalprice * res.size);
        let listOp = {
          ...res,
          olddiscount: res.discount,
          oldppc: res.discountprice,
          discountprice: res.stoneprice,
          olddiscountprice: res.stoneprice,
        };
        newListData.push(listOp);
        lInvoiceAmount += Number(actualPrice * ((100 + res.discount) / 100));

        // If stoneoldstatus is not null that means stone is in LOCATION_TRANSFER
        if (res.stoneoldstatus !== null) {
          setDisableInvoiceButton(true);
          setWarningMessage("Stone is IN_TRANSIT. Please Mark stone as received before placing INVOICE");
        }

        // If Rapnet Price and new Rapnet Price is not same then show New Rap Column
        if (Constants.loggedInUser.usertype === "E" && res.originalprice.toFixed(2) !== res.neworiginalprice.toFixed(2)) {
          hideColumnFlag = false;
        }

        return true;
      });

      let tempInvoiceAmount = lActualDiscountPrice.toFixed(2);
      let tempPricePerAmount = (lActualDiscountPrice / lTotalCarat).toFixed(2);
      let tempDiscount = ((100 - (lActualDiscountPrice * 100) / lActualPrice) * -1).toFixed(2);

      setIsColumnsHidden(hideColumnFlag);
      setTotalDiscount(tempDiscount);
      setOldTotalDiscount(tempDiscount);
      setTotalCarat(lTotalCarat.toFixed(2));
      setActualAmount(lActualPrice.toFixed(2));
      setListData(newListData);
      setDefaultListData(newListData);
      setInvoiceAmount(tempInvoiceAmount);
      setOldTotalInvoiceAmount(tempInvoiceAmount);
      setOldTotalPPC(tempPricePerAmount);
      setAvgPricePerCarats(tempPricePerAmount);
      setNewTotalDiscount(tempDiscount);
      setNewTotalPPC(tempPricePerAmount);
      setNewTotalInvoiceAmount(tempInvoiceAmount);
      setPayableAmount(((Number(lInvoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2));
      setAddLessAmount(0);
      setAddLessPercent(0);
      setOldAddLessAmount(0);
      setOldAddLessPercent(0);
      setApplyValue(0);
      setStonesLoader(false);
    });
  };

  const setAllCompanyData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.name, companylocationid: data.locationid, country: data.country };
      optionsArray.push(option);
      return true;
    });
    if (sourceData) {
      prepareProformaDetailData(sourceData[0]);
    } else {
      const findTradingCompany = optionsArray.find((data) => data.label === "PANSURIYA IMPEX LLP");
      setCompany(company !== "" && optionsArray.length > 0 ? (findTradingCompany ? findTradingCompany : optionsArray[0]) : company);
    }
    setCompanyOptions(optionsArray);
  };

  const setInvoiceToCompany = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.companyname, country: data.country };
      optionsArray.push(option);
      return true;
    });
    if (sourceData && sourceData.invoicecustomercompanyname !== null && optionsArray.length > 0) {
      let invoiceTo = optionsArray.filter(data => data.value === sourceData[0].invoicecustomerid);
      if (invoiceTo.length === 0) {
        setInvoiceTo({ label: sourceData[0].invoicecustomercompanyname, value: sourceData[0].invoicecustomerid, country: sourceData[0].invoicecountry });
      } else {
        setInvoiceTo(invoiceTo[0]);
      }
    } else if (sourceData && sourceData.invoicecustomercompanyname !== null && optionsArray.length === 0) {
      setInvoiceTo({ label: sourceData[0].invoicecustomercompanyname, value: sourceData[0].invoicecustomerid, country: sourceData[0].invoicecountry });
    } else {
      let invoiceTo = optionsArray.filter(data => data.value === customer.value);
      invoiceTo.length === 0 ? setInvoiceTo([customer]) : setInvoiceTo(invoiceTo);
    }

    setInvoiceToCompanyOptions(optionsArray);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInputValue(userInputValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [userInputValue]);

  const filteredUserOptions = useMemo(() => {
    if (!debouncedInputValue) {
      return invoiceToCompanyOptions.slice(0, 100);
    }
    return invoiceToCompanyOptions.filter(option =>
      option.label.toLowerCase().includes(debouncedInputValue.toLowerCase())
    ).slice(0, 500);
  }, [debouncedInputValue, invoiceToCompanyOptions]);

  const prepareStoneData = () => {
    let selectedStoneId = [];

    listData.map((iRow) => {
      let obj = {
        stoneid: iRow.stoneid,
        oldstatus: iRow.status,
        newstatus: "SELL",
        defaultdiscount: Number(defaultlistData.find((list) => list.stoneid === iRow.stoneid).discount),
        actualdiscount: Number(iRow.discount),
        size: Number(iRow.size),
        originalprice: Number(iRow.originalprice),
        stoneprice: Number(iRow.discountprice),
        discountprice: Number((iRow.discountprice / iRow.size).toFixed(2)),
      };
      selectedStoneId.push(obj);
      return true;
    });

    return selectedStoneId;
  };

  let prepareData = () => {
    let data = {
      id: sourceData ? sourceData[0].id : null,
      date: Utility.ConvertLocalTimeToUtc(date).slice(0, 11) + "00:00:00.000Z",
      customerid: customer.value,
      brokerid: broker === null || broker.brokerid === -1 ? -1 : broker.brokerid,
      userid: Constants.loggedInUser.id,
      tradingcompanyid: company.value,
      export: type.value === "local" ? false : true,
      exchangerate: parseFloat(exchangeRate),
      exchangecurrency: currency,
      shippingcost: parseFloat(shippingCost),
      finalpayableamount: parseFloat(payableAmount),
      remarks: remark,
      terms: terms,
      days: invoiceDays,
      stones: prepareStoneData(),
      memoid: memoId
        ? memoId.filter((value, index, array) => array.indexOf(value) === index)
        : undefined,
      canedit: fieldPermission ? false : true,
      invoicecustomerid: !invoiceTo ? customer.value : invoiceTo.length === 1 ? invoiceTo[0].value : invoiceTo.value,
      addlesspercent: parseFloat(addLessPercent),
      addlessamount: parseFloat(addLessAmount),
      addtoinvoice: addToInvoice,
    };
    if (type.value !== "local") data = { ...exportData, ...data };
    return data;
  };

  const saveInvoice = () => {
    let allowInvoice = listData.find(iStone => iStone.locationid !== company.companylocationid);

    if (disableInvoiceButton || allowInvoice) {
      if (warningMessage === "") {
        setWarningMessage("Make sure stone location is same as the trading company location before placing INVOICE");
      }
      setShowWarning(true);
    } else {
      setDisableAllButtons(true);
      let data = prepareData();

      if (handleInvoice) {
        if (handleValidation) {
          if (handleValidation(data)) {
            handleInvoice(data);
          } else {
            setShowError(true);
          }
        } else {
          handleInvoice(data);
        }
      }
    }
  };

  const saveProforma = () => {
    setDisableAllButtons(true);
    let data = prepareData();

    if (handleProforma) {
      if (handleValidation) {
        if (handleValidation(data)) {
          handleProforma(data);
        } else {
          setShowError(true);
        }
      } else {
        handleProforma(data);
      }
    }
  };

  const updateProforma = () => {
    setDisableAllButtons(true);
    let data = prepareData();

    if (handleUpdateProforma) {
      if (handleValidation) {
        if (handleValidation(data)) {
          handleUpdateProforma(data);
        } else {
          setShowError(true);
        }
      } else {
        handleUpdateProforma(data);
      }
    }
  };

  const updateProformaToInvoice = () => {
    let allowInvoice = listData.find(iStone => iStone.locationid !== company.companylocationid);

    if (disableInvoiceButton || allowInvoice) {
      if (warningMessage === "") {
        setWarningMessage("Make sure stone location is same as the trading company location before placing INVOICE");
      }
      setShowWarning(true);
    } else {
      setDisableAllButtons(true);
      let data = prepareData();

      if (handleUpdateProformaToInvoice) {
        if (handleValidation) {
          if (handleValidation(data)) {
            handleUpdateProformaToInvoice(data);
          } else {
            setShowError(true);
          }
        } else {
          handleUpdateProformaToInvoice(data);
        }
      }
    }
  };

  const closeErrorDialog = () => {
    setUploadSuccessSnackbar(false);
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleStoneDetailModal = (params) => {
    setStoneDetailModalId(params.value);
    setShowStoneDetailModal(true);
  };

  const prepareColumns = () => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (fieldPermission) {
          if (columnData.field === "originalprice") {
            columnNames.push(
              {
                field: "neworiginalprice",
                headerName: "NEW RAP",
                headerAlign: "center",
                align: "center",
                width: 90,
                renderCell: (params) => params.row.originalprice.toFixed(2) === params.row.neworiginalprice.toFixed(2) ? " - " : Utility.ConvertNumberWithSpecifiedDigits(params.row.neworiginalprice),
                cellClassName: (params) => params.row.originalprice.toFixed(2) === params.row.neworiginalprice.toFixed(2) ? "" : 'yellowCell',
              }
            )
          }
          else if (columnData.field === "olddiscount") {
            columnNames.push(
              {
                field: "discount",
                headerName: "NEW DIS",
                headerAlign: "center",
                align: "center",
                width: 110,
                editable: ((fieldPermission && canEdit) || (!notPermitted)) ? true : false,
                renderCell: (params) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)}</span>
                    {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                  </div>
                ),
                cellClassName: (params) => 'lavenderCell',
              }
            )
          }
          else if (columnData.field === "oldppc") {
            columnNames.push(
              {
                field: "discountpricepercarat",
                headerName: "NEW PPC",
                headerAlign: "center",
                align: "center",
                width: 130,
                editable: ((fieldPermission && canEdit) || (!notPermitted)) ? true : false,
                renderCell: (params) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '10px' }}>{params.value}</span>
                    {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                  </div>
                ),
                valueGetter: (params) =>
                  (Number(params.row.discountprice) / Number(params.row.size)).toFixed(2),
                cellClassName: (params) => 'lavenderCell',
              }
            )
          }
          else if (columnData.field === "olddiscountprice") {
            columnNames.push({
              field: "discountprice",
              headerName: "NEW TOTAL",
              headerAlign: "center",
              align: "center",
              width: 120,
              renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '10px' }}>{Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.discountprice))}</span>
                  {params.colDef.editable && <EditIcon style={{ marginLeft: 10, marginBottom: 3, fontSize: '1rem', marginRight: -16 }} />}
                </div>
              ),
              editable: ((fieldPermission && canEdit) || (!notPermitted)) ? true : false,
              cellClassName: (params) => 'lavenderCell',
            })
          }
        }
        if (columnData.field === "discountprice" || columnData.field === "olddiscountprice") {
          columnNames.push({
            field: "addlesspercent",
            headerName: "ADD/LESS",
            headerAlign: "center",
            align: "center",
            width: 90,
            renderCell: renderCellExpand,
            editable: false,
            // cellClassName: (params) => 'blueCell',
          })
        } else if (columnData.field === "status") {
          columnNames.push({
            field: "stonesubstatus",
            headerName: "STONE SUB STATUS",
            headerAlign: "center",
            align: "center",
            width: 140,
            renderCell: (params) => params.row.stoneoldstatus !== null ? "IN_TRANSIT" : (params.row.tradingcompanylocation !== params.row.stonelocation ? "YET_TO_ARRIVE" : " - "),
            valueGetter: (params) => params.row.stoneoldstatus !== null ? "IN_TRANSIT" : (params.row.tradingcompanylocation !== params.row.stonelocation ? "YET_TO_ARRIVE" : " - "),
          });
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      width: 100,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: (params) => `super-app-theme--${params.row.status.toUpperCase()}`,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
    },
    "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "left",
      width: 130,
      renderCell: (params) => !(params.row.stoneoldstatus !== null || params.row.tradingcompanylocation !== params.row.stonelocation) ? params.value : (
        <Box
          sx={{
            "& .MuiBadge-badge": {
              height: "0.75rem !important",
              padding: "2px 4px !important",
              fontSize: "8px",
              top: "-1px",
              right: "-20px",
              backgroundColor: "#E5D9F2 !important",
              color: "#624E88 !important",
              fontWeight: "700"
            },
          }}
        >
          <Badge
            badgeContent={"TRANSIT"}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {params.value}
          </Badge>
        </Box>
      ),
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 118,
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      width: 55,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "originalprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.originalprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "olddiscount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.olddiscount),
      cellClassName: (params) => 'bold-cell',
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "oldppc",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.oldppc),
      cellClassName: (params) => 'bold-cell',
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "olddiscountprice",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.olddiscountprice)),
      cellClassName: (params) => 'bold-cell',
    },
  }

  const handleProcessRowUpdateError = (error) => {
    // console.error(error);
  };

  const processRowUpdate = (newRow, oldRow) => {

    const changedFeilds = Utility.getChangedFields(newRow, oldRow);
    if (changedFeilds.length > 0) {
      const { id, field, value } = changedFeilds[0];
      const rowData = [...listData];
      let totalInvoice = 0;
      let buttonDisable = false;
      if (((value > 1000 || value < -100) && field === "discount") || (value <= 0 && (field === "discountprice" || field === "discountpricepercarat"))) {
        buttonDisable = true;
      }
      const updatedListData = rowData.map((row) => {
        if (buttonDisable === false && row.stoneid !== id && (row.editeddiscount > 1000 || row.editeddiscount < -100 || row.editedtotal <= 0)) {
          buttonDisable = true;
        }

        if (row.stoneid === id) {
          let actualPrice = row.originalprice * row.size;
          let newRow = { ...row };
          if (field === "discount") {
            newRow = {
              ...row,
              [field]: Number(value),
              discountprice: Number(
                actualPrice * ((100 + Number(value)) / 100)
              ).toFixed(2),
            };
          } else if (field === "discountpricepercarat") {
            let tdiscount = parseFloat(((((Number(value) * row.size) / actualPrice) * 100) - 100).toFixed(2));
            newRow = {
              ...row,
              [field]: Number(value),
              discount: tdiscount,
              discountprice: parseFloat((Number(value) * row.size).toFixed(2)),
            }
          }
          else {
            newRow = {
              ...row,
              [field]: Number(value),
              discount:
                Number(100 - (Number(value) * 100) / actualPrice).toFixed(2) * -1,
            };
          }
          return newRow;
        }
        return row;
      });
      setListData(updatedListData);
      setSellButtonDisable(buttonDisable);

      updatedListData.map((row) => {
        totalInvoice += parseFloat(row.discountprice);
        return true;
      });
      setNewTotalDiscount(((100 - Number(totalInvoice * 100) / Number(actualAmount)
      ) * -1).toFixed(2));
      setNewTotalPPC((totalInvoice / totalCarat).toFixed(2));
      setNewTotalInvoiceAmount(totalInvoice.toFixed(2));
      setInvoiceAmount(Number(totalInvoice).toFixed(2));
      setAvgPricePerCarats(parseFloat((totalInvoice / totalCarat).toFixed(2)));
      setPayableAmount((
        (Number(totalInvoice) + Number(shippingCost) + Number(addLessAmount)) *
        Number(exchangeRate)
      ).toFixed(2)
      );
      setTotalDiscount(
        Number(
          100 - Number(totalInvoice * 100) / Number(actualAmount)
        ).toFixed(2) * -1
      );

      addLessPercentCalc(addLessPercent, updatedListData);

      const updatedRow = updatedListData.find(row => row.stoneid === id);
      return updatedRow;
    } else {
      // No changes detected, return the newRow to trigger exit edit mode
      return { ...newRow };
    }
  }

  const handleDiscount = (event) => {

    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalDiscount) {

      (parseFloat(event.target.value) < -100 || parseFloat(event.target.value) >= 1000) ? setSellButtonDisable(true) : setSellButtonDisable(false)

      let newDiscount = event.target.value;

      let newInvoiceAmount = 0;
      let actualPrice = 0;
      listData.map((iList) => {
        let iActualPrice = parseFloat(iList.size * iList.originalprice);
        actualPrice += iActualPrice;
        return true;
      });

      newInvoiceAmount = actualPrice + (actualPrice * (parseFloat(newDiscount) / 100));
      handleInvoicee({
        key: 'Enter', // Example key
        type: 'blur', // Example type
        target: { value: parseFloat(newInvoiceAmount.toFixed(2)) },
        message: "discount"
      });
    }
  };

  const handleInvoicee = (event) => {
    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalInvoiceAmount) {
      parseFloat(event.target.value) <= 0 ? setSellButtonDisable(true) : setSellButtonDisable(false)
      if (event.target.value < 0) return;
      let newInvoiceAmount = event.target.value;
      let newList = [];
      let lActualPrice = 0;
      let lInvoiceAmount = 0;
      let lastIndex = listData.length - 1;
      listData.map((iList, index) => {

        let tdiscount = parseFloat((newInvoiceAmount / oldTotalInvoiceAmount).toFixed(5));
        let iDiscountPrice = parseFloat((tdiscount * parseFloat(iList.olddiscountprice)).toFixed(2));
        if (index === lastIndex) iDiscountPrice = parseFloat((newInvoiceAmount - lInvoiceAmount).toFixed(2));
        let iActualPrice = parseFloat((iList.originalprice * iList.size).toFixed(2));

        let listOp = {
          ...iList,
          discount: parseFloat((((iActualPrice - iDiscountPrice) / iActualPrice) * 100).toFixed(2)) * -1,
          discountprice: Number(iDiscountPrice),
        };

        newList.push(listOp);
        lActualPrice += iActualPrice;
        lInvoiceAmount += Number(iDiscountPrice);
        return newList;
      });
      setListData(newList);
      setTotalDiscount(
        Number(100 - (lInvoiceAmount * 100) / lActualPrice).toFixed(2) * -1
      );
      setInvoiceAmount(event.message === "PPC" ? lInvoiceAmount.toFixed(2) : newInvoiceAmount);
      setNewTotalInvoiceAmount(event.message === "PPC" ? lInvoiceAmount.toFixed(2) : parseFloat(newInvoiceAmount).toFixed(2));
      setNewTotalDiscount(((100 - (lInvoiceAmount * 100) / lActualPrice) * -1).toFixed(2));
      setNewTotalPPC((lInvoiceAmount / totalCarat).toFixed(2));
      setAvgPricePerCarats(parseFloat((lInvoiceAmount / totalCarat).toFixed(2)))
      addLessPercentCalc(addLessPercent, newList);
    }
  };

  const handlePricePerCarat = (event) => {

    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== newTotalPPC) {

      parseFloat(event.target.value) <= 0 ? setSellButtonDisable(true) : setSellButtonDisable(false)

      if (event.target.value < 0) return;

      let newPricePerCarat = event.target.value;
      setInvoiceAmount(parseFloat((totalCarat * newPricePerCarat).toFixed(2)));

      handleInvoicee({
        key: 'Enter', // Example key
        type: 'blur', // Example type
        target: { value: parseFloat((totalCarat * newPricePerCarat).toFixed(2)) }, // Example target with value
        message: "PPC",
      });

      setAvgPricePerCarats(newPricePerCarat);
      setNewTotalPPC(newPricePerCarat);
    }
  };

  const addLessPercentCalc = (value, data) => {

    let newList = [];
    let addLessAmount = 0;
    let addLessPercent = value;
    data.map((iList, index) => {
      addLessAmount += iList.discountprice * (addLessPercent / 100);
      let listOp = {
        ...iList,
        addlesspercent: parseFloat(addLessPercent).toFixed(2),
      };
      newList.push(listOp);
      return newList;
    });
    setListData(newList);
    setOldAddLessPercent(addLessPercent);
    setPayableAmount(
      ((Number(invoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2));
    setAddLessAmount(parseFloat(addLessAmount).toFixed(2));
  }

  const handleAddLessPercent = (event) => {
    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== oldAddLessPercent) {
      addLessPercentCalc(event.target.value, listData);
    }
  };


  const handleAddLessAmount = (event) => {
    if ((event.key === 'Enter' || event.type === 'blur') && event.target.value !== oldAddLessAmount) {
      let newList = [];
      let addLessAmount = event.target.value;
      let addLessPercent = ((addLessAmount / invoiceAmount) * 100);
      listData.map((iList, index) => {
        // addLessAmount += iList.discountprice * (addLessPercent / 100);
        let listOp = {
          ...iList,
          addlesspercent: parseFloat(addLessPercent).toFixed(2),
        };

        newList.push(listOp);
        return newList;
      });
      setListData(newList);
      setOldAddLessAmount(addLessAmount);
      setPayableAmount(
        ((Number(invoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * exchangeRate).toFixed(2));
      setAddLessPercent(parseFloat(addLessPercent).toFixed(2));
    }
  };

  const applyValueToAllFields = () => {
    let totalInvoice = 0;
    const newList = [];
    if (applyToAll.label === "Discount") {
      listData.map((iList) => {
        let actualPrice = iList.originalprice * iList.size;
        let value = (parseFloat(iList.olddiscount) + parseFloat(applyValue)).toFixed(2);
        let newRow = {
          ...iList,
          discount: Number(value),
          discountprice: parseFloat(Number(
            actualPrice * ((100 + Number(value)) / 100)
          ).toFixed(2)),
        }

        newList.push(newRow);

        return true;
      })
    } else if (applyToAll.label === "PPC") {
      listData.map((iList) => {
        let actualPrice = iList.originalprice * iList.size;
        let value = (parseFloat(iList.oldppc) + parseFloat(applyValue)).toFixed(2);
        let tdiscount = parseFloat(((((Number(value) * iList.size) / actualPrice) * 100) - 100).toFixed(2));
        let newRow = {
          ...iList,
          discountpricepercarat: Number(value),
          discount: tdiscount,
          discountprice: parseFloat((Number(value) * iList.size).toFixed(2)),
        }
        newList.push(newRow);

        return true;
      })
    } else {
      listData.map((iList) => {
        let value = (parseFloat(iList.olddiscountprice) + parseFloat(applyValue)).toFixed(2);
        let tPPC = parseFloat((Number(value) / iList.size).toFixed(2));

        let newRow = {
          ...iList,
          discountpricepercarat: tPPC,
          discount: ((tPPC / iList.originalprice) * 100) - 100,
          discountprice: Number(value)
        }
        newList.push(newRow);

        return true;
      })
    }

    setListData(newList);
    newList.map((row) => {
      totalInvoice += row.discountprice;
      return true;
    });
    setInvoiceAmount(totalInvoice.toFixed(2));
    setAvgPricePerCarats(parseFloat((totalInvoice / totalCarat).toFixed(2)));
    setPayableAmount(
      (
        (Number(totalInvoice) + Number(shippingCost) + Number(addLessAmount)) *
        Number(exchangeRate)
      ).toFixed(2)
    );
    setTotalDiscount(
      Number(
        100 - Number(totalInvoice * 100) / Number(actualAmount)
      ).toFixed(2) * -1
    );
    setNewTotalInvoiceAmount(totalInvoice.toFixed(2));
    setNewTotalDiscount(((100 - (totalInvoice * 100) / actualAmount) * -1).toFixed(2));
    setNewTotalPPC((totalInvoice / totalCarat).toFixed(2));
  }

  const handleShippingCost = (val) => {
    setShippingCost(val);
    setPayableAmount(
      ((Number(invoiceAmount) + Number(val) + Number(addLessAmount)) * exchangeRate).toFixed(
        2
      )
    );
  };

  const handleExchangeRate = (e) => {
    setExchangeRate(Number(e.target.value));
    setPayableAmount(
      ((Number(invoiceAmount) + Number(shippingCost) + Number(addLessAmount)) * e.target.value).toFixed(
        2
      )
    );
  };

  const applyNewRapnetPrice = () => {
    setStonesLoader(true);
    let lTotalCarat = 0;
    let lActualPrice = 0;
    let lInvoiceAmount = 0;
    let hideColumnFlag = true;

    let updatedListData = listData.map(iStone => {
      if (selectionModel.includes(iStone.stoneid) && iStone.originalprice.toFixed(2) !== iStone.neworiginalprice.toFixed(2)) {
        let diffRapnetPrice = iStone.neworiginalprice - iStone.originalprice;

        iStone.originalprice = iStone.neworiginalprice;
        if (diffRapnetPrice > 0) {
          // Follow Discount
          iStone.oldppc = iStone.originalprice + (iStone.originalprice * (iStone.olddiscount / 100));
          iStone.olddiscountprice = iStone.size * iStone.oldppc;

          iStone.discountpricepercarat = iStone.originalprice + (iStone.originalprice * (iStone.discount / 100));
          iStone.discountprice = iStone.size * iStone.discountpricepercarat;
        } else {
          // Follow PPC
          iStone.olddiscount = parseFloat((((iStone.oldppc * 100) / iStone.originalprice) - 100).toFixed(2));
          iStone.oldppc = iStone.originalprice + (iStone.originalprice * (iStone.olddiscount / 100));
          iStone.olddiscountprice = iStone.size * iStone.oldppc;

          iStone.discount = parseFloat((((iStone.discountpricepercarat * 100) / iStone.originalprice) - 100).toFixed(2));
          iStone.discountpricepercarat = iStone.originalprice + (iStone.originalprice * (iStone.discount / 100));
          iStone.discountprice = iStone.size * iStone.discountpricepercarat;
        }
      } else if (iStone.originalprice.toFixed(2) !== iStone.neworiginalprice.toFixed(2)) {
        hideColumnFlag = false;
      }

      lTotalCarat += Number(iStone.size);
      lActualPrice += Number(iStone.size * iStone.originalprice);
      let actualPrice = Number(iStone.originalprice * iStone.size);
      lInvoiceAmount += Number(actualPrice * ((100 + iStone.discount) / 100));

      return iStone;
    })

    setTotalDiscount(
      Number(100 - (lInvoiceAmount * 100) / lActualPrice).toFixed(2) * -1
    );
    setOldTotalDiscount(
      Number(100 - (lInvoiceAmount * 100) / lActualPrice).toFixed(2) * -1
    );
    setTotalCarat(lTotalCarat.toFixed(2));
    setActualAmount(lActualPrice.toFixed(2));
    setListData(updatedListData);
    setDefaultListData(updatedListData);
    setInvoiceAmount(lInvoiceAmount.toFixed(2));
    setOldTotalInvoiceAmount(lInvoiceAmount.toFixed(2));
    setOldTotalPPC((lInvoiceAmount / lTotalCarat.toFixed(2)).toFixed(2));
    setAvgPricePerCarats((lInvoiceAmount / lTotalCarat.toFixed(2)).toFixed(2));
    setNewTotalDiscount(((100 - (lInvoiceAmount * 100) / lActualPrice) * -1).toFixed(2));
    setNewTotalPPC((lInvoiceAmount / lTotalCarat.toFixed(2)).toFixed(2));
    setNewTotalInvoiceAmount(lInvoiceAmount.toFixed(2));
    setPayableAmount(
      (
        (Number(lInvoiceAmount) + Number(shippingCost) + Number(addLessAmount)) *
        exchangeRate
      ).toFixed(2)
    );
    setAddLessAmount(0);
    setAddLessPercent(0);
    setOldAddLessAmount(0);
    setOldAddLessPercent(0);
    setApplyValue(0);
    setIsColumnsHidden(hideColumnFlag);
    setSelectionModel([]);
    setStonesLoader(false);
  }

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const handleProformaDetailChange = (event, value) => {
    setProformaPaginatedValueId(sourceData[value - 1].proformaid);
    prepareProformaDetailData(sourceData[value - 1]);
    setPage(value);
  };

  const rows = listData;

  const columns = isColumnsHidden
    ? columnNames.filter((col) => col.field !== "neworiginalprice")
    : columnNames.filter((col) => col.field !== "country");

  return (
    <div>
      <Modal backdrop="static" show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
        {uploadSuccessSnackbar ? (
          <CommonSnackbar
            message={
              changedData === true
                ? `File loaded Successfully`
                : `The headers in the CSV file do not match the expected headers or Stone ids do not match `
            }
            variant={changedData === true ? "success" : "error"}
            autoHide={Constants.SnackBarCloseTimer}
            show={uploadSuccessSnackbar}
            title={changedData === true ? "Success" : "Error"}
            handleClose={closeErrorDialog}
          />
        ) : null}
        {showStoneDetailModal ? (
          <StoneDetailModal
            show={showStoneDetailModal}
            stoneId={stoneDetailModalId}
            handleClose={() => setShowStoneDetailModal(false)}
          />
        ) : null}
        <CommonSnackbar
          show={showError}
          message={
            <Box>
              Sell stones validation Failed
              <br /> Please enter correct data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={closeErrorDialog}
          title="Validation Failure"
        />
        <CommonSnackbar
          show={showSnackbar}
          message={snackbarMessage}
          variant={snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={snackbarVariant === "success" ? "Success" :
            snackbarVariant === "error" ? "Failed" : "Warning"}
          handleClose={() => setShowSnackbar(false)}
        />
        {showWarning ? (
          <CommonSnackbar
            show={showWarning}
            message={warningMessage}
            title={"Warning"}
            variant={"warning"}
            autoHide={Constants.SnackBarCloseTimer}
            handleClose={() => {
              setShowWarning(false);
              setWarningMessage("");
            }}
          />) : null}

        {showUserDetailModal ? (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(1px)",
                zIndex: 1299,
              }}
            />
            <UserDetailModal
              show={true}
              handleClose={() => setShowUserDetailModal(false)}
              handleSelect={(selectedOption) => {
                const selectedCustomers = brokerOptions.filter(opt =>
                  selectedOption.includes(opt.value)
                );
                setBroker(selectedCustomers[0]);
                setShowUserDetailModal(false)
              }}
              userids={brokerOptions.filter(option => option.value !== -1).map(cust => cust.value)}
              selectedIds={broker ? [broker.value] : []}
              usertype={"B"}
              loading={showUserDetailModal}
              isMulti={false}
            />
          </>
        ) : null}
        <Modal.Header closeButton>
          <Modal.Title>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
                style={{ marginRight: '12px' }}
              />
              {proformaButton ? (Utility.GetBuyOrSell() + " Stones") : "Convert Proforma to Invoice"}
              {kyc === false && (
                <span
                  style={{
                    color: '#d9534f',
                    marginLeft: '20px',
                    fontSize: '1.1rem',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <BiSolidError style={{ marginRight: '8px', fontSize: '1.3rem', color: '#ffc107' }} />
                  KYC verification is pending -- Please complete it to proceed further.
                </span>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box>
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 1fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap="15px"
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                  <Typography sx={{ width: "145px" }}>Customer Company</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {customer.value + " | " + customer.label}
                  </Typography>
                </Box>

                {Constants.loggedInUser.usertype !== 'C' ? (
                  <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingRight: "15px" }}>
                    <Typography sx={{ width: "155px" }}>Broker Company</Typography>
                    {Constants.loggedInUser.usertype !== "B" ? (
                      <Box display={"flex"} alignItems={"center"}>
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            width: "60%",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ flexGrow: 1 }}>
                            <Select menuPlacement="auto"
                              blurInputOnSelect={false}
                              menuPortalTarget={document.body}
                              styles={{
                                ...Constants.Styles,
                                control: (base) => ({
                                  ...base,
                                  width: '20rem',
                                  minHeight: "38px"
                                }),
                              }}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              options={brokerOptions}
                              value={broker === null ? { value: -1, label: " - " } : { value: broker.brokerid, label: broker.label }}
                              isClearable
                              onChange={(e) => setBroker(e)}
                              isDisabled={(canEdit || !notPermitted) ? false : true}
                            />
                          </Box>
                        </Box>
                        <Tooltip title="View More Data">
                          <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                            <OpenInNewIcon
                              style={{ fontSize: "20px", marginBottom: "3px" }}
                              onClick={() => {
                                setShowUserDetailModal(true);
                              }}
                              color="action"
                            />
                          </span>
                        </Tooltip>
                      </Box>
                    ) : (
                      <Typography sx={{ fontWeight: "bold" }}>
                        {broker.label}
                      </Typography>
                    )}
                  </Box>

                ) : null}

                <Box sx={{ display: "flex", width: "100%", mt: 1, gap: "15px" }}>
                  <Typography sx={{ width: "145px" }}>User Company</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>{lUser}</Typography>
                </Box>
              </Box>
              {fieldPermission ? (
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "15px",
                    }}
                  >
                    <Box sx={{ alignSelf: "center", mt: 1, width: "175px" }}>
                      <Typography>Trading Company</Typography>
                    </Box>
                    <Box
                      sx={{
                        alignSelf: "center",
                        width: "100%",
                        mt: 1,
                      }}
                    >
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={company}
                        isSearchable={true}
                        name="Trading Company"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={companyOptions}
                        onChange={(selectedOption) => {
                          setCompany(selectedOption)
                        }}
                        isDisabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "15px",
                      marginTop: "10px"
                    }}
                  >
                    <Box sx={{ alignSelf: "center", mt: 1, width: "175px" }}>
                      <Typography>Type</Typography>
                    </Box>
                    <Box
                      sx={{
                        alignSelf: "center",
                        mt: 1,
                        width: "100%",
                      }}
                    >
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        options={typeOptions}
                        value={type}
                        onChange={(e) => setType(e)}
                        isDisabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                      />
                    </Box>
                  </Box>
                </Box>
              ) : null}
              {fieldPermission ? (


                <Box display={"flex"} gap="15px" flexDirection={"column"}>
                  {" "}
                  <Box
                    sx={{
                      display: "flex",
                      gap: "15px",
                    }}
                  >
                    <Box sx={{ alignSelf: "center", mt: 1, width: "137px" }}>
                      <Typography>Invoice To</Typography>
                    </Box>
                    <Box
                      sx={{
                        alignSelf: "center",
                        mt: 1,
                        width: "100%",
                      }}
                    >
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={invoiceTo}
                        isSearchable={true}
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        options={filteredUserOptions}
                        onChange={(e) => setInvoiceTo(e)}
                        inputValue={userInputValue}
                        onInputChange={(inputValue) => setUserInputValue(inputValue)}
                        isDisabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                      />
                    </Box>
                  </Box>
                  <Box display={"flex"} gap={"72px"}>
                    <Box
                      width={"50%"}
                      display={"flex"}
                      gap="15px"
                      // mt={sourceData !== undefined && sourceData.length > 1 ? 0 : 2}
                      alignItems={"center"}
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          height: "0.5rem",
                        },
                        "& .MuiTextField-root": {
                          marginTop: 0,
                          marginBottom: 0
                        }
                      }}
                    >
                      <Typography sx={{ width: "192px" }}>Proforma Date</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Proforma Date"
                          disabled
                          value={proformaDate === "" ? formattedDate : proformaDate}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box
                      width={"38%"}
                      display={"flex"}
                      gap="15px"
                      // mt={sourceData !== undefined && sourceData.length > 1 ? 0 : 2}
                      alignItems={"center"}
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          height: "0.5rem",
                        },
                        "& .MuiTextField-root": {
                          marginTop: 0,
                          marginBottom: 0
                        }
                      }}
                    >
                      <Typography sx={{ width: "50px" }}>Date</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Date"
                          disabled
                          value={formattedDate}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Box>
                  {sourceData !== undefined && sourceData.length > 1 ? (
                    <Stack>
                      <Typography textAlign={"center"}>
                        Proforma: {proformaPaginatedValueId}
                      </Typography>
                      <Pagination
                        count={sourceData.length}
                        page={page}
                        onChange={handleProformaDetailChange}
                        sx={{ alignSelf: "center" }}
                        variant="outlined"
                        color="primary"
                        size="small"
                        shape="rounded"
                      />
                    </Stack>
                  ) : null}
                </Box>
              ) : null}
            </Box>
            {type.value === "export" && Constants.loggedInUser.usertype === 'E' ? (
              <ExportComponent
                canEdit={canEdit}
                countryOfOrigin={countryOfOrigin}
                insurredBy={insurredBy}
                portOfLoading={portOfLoading}
                countryOfFinalDestination={countryOfFinalDestination}
                shippedBy={shippedBy}
                portOfDischarge={portOfDischarge}
                finalDestination={finalDestination}
                bankThrough={bankThrough}
                exportComponentData={exportComponentData}
                notPermitted={notPermitted}
              />
            ) : null}
            <Box
              sx={{
                width: "100%",
                position: "relative",
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "8px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "15px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "22px",
                  fontSize: Constants.defaultTableFontSize,
                  fontWeight: Constants.defaultFontWeight,
                },

                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                "& .yellowCell": {
                  color: "#080808",
                  backgroundColor: "#F9F08D",
                },
                "& .blueCell": {
                  color: "#080808",
                  backgroundColor: "#B6B9D6",
                },
                "& .bold-cell": {
                  fontWeight: "800",
                },
                mt: 2
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={true}
                autoHeight
                slots={{ toolbar: GridToolbar }}
                rows={rows}
                columns={columns}
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}
                getRowId={(row) => row.stoneid}
                checkboxSelection={!isColumnsHidden}
                onRowSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                }}
                loading={stonesLoader}
                rowSelectionModel={selectionModel}
                density="compact"
                sx={{ fontSize: Constants.defaultTableFontSize, fontWeight: 'bold' }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      locationid: false,
                      cutpolsym: false,
                      createdat: false,
                      quality: false,
                      stonesubstatus: false
                    },
                  },
                  sorting: {
                    sortModel: [{ field: "stoneid", sort: "asc" }],
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                apiRef={apiRef}
                onCellClick={handleCellClick}
                editMode="cell"
              />

              {fieldPermission && !isColumnsHidden ? (
                <Box sx={{
                  position: "absolute",
                  left: "0.4rem",
                  top: "1px"
                }}>
                  <CommonStoneSelection
                    title={"Enter multiple Stone Ids"}
                    handleSelection={handleSelection}
                    bgColor='#454545'
                    buttonDisabled={rows.length === 0} />
                </Box>
              ) : null}


              {fieldPermission ? (<Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  position: "absolute",
                  top: "4px",
                  right: "265px",
                  fontSize: "14px",
                  "& .apply-value": {
                    "& .MuiInputBase-input": {
                      padding: "6px 14px"
                    }
                  },
                  "& .MuiTextField-root": {
                    marginTop: 0,
                    marginBottom: 0
                  }
                }}
              >

                <LoadingButton
                  component="label"
                  variant="outlined"
                  size="small"
                  color="secondary"
                  loading={stonesLoader}
                  loadingPosition="start"
                  startIcon={<CheckCircleIcon />}
                  disabled={selectionModel.length === 0}
                  onClick={applyNewRapnetPrice}
                  sx={{ marginRight: "7.2rem" }}>
                  Apply New RAP
                </LoadingButton>

                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, margin: 0 }}>Discount / PPC</Typography>
                </Box>
                <TextField
                  fullWidth
                  sx={{ width: "130px", height: "35px", marginTop: "2px" }}
                  disabled={(canEdit || !notPermitted) ? false : true}
                  value={applyValue}
                  onChange={(e) => setApplyValue(e.target.value)}
                  className="apply-value"
                />
                <Box
                  sx={{
                    alignSelf: "center",
                    width: "120px",
                    marginTop: "-3px",
                    height: "35px"
                  }}
                >
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={applyToAll}
                    isSearchable={true}
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={applyToAllOption}
                    onChange={(selectedOption) => setApplyToAll(selectedOption)}
                    isDisabled={(canEdit || !notPermitted) ? false : true}
                  />
                </Box>

                <LoadingButton
                  variant="contained"
                  onClick={applyValueToAllFields}
                  type="Submit"
                  color="success"
                  startIcon={<CheckIcon />}
                  sx={{ width: "105px", height: "35px" }}
                  disabled={(canEdit || !notPermitted) ? false : true}
                >
                  Apply
                </LoadingButton>

                <Tooltip title="Download Sample Stock Sell Upload">
                  <a
                    href="/demo_excel/SampleStockSellUpload.csv"
                    download="SampleStockSellUpload.csv"
                    style={{ color: "red", marginRight: "2px", marginLeft: "2px" }}
                  >
                    <BackupTable size={25} />
                  </a>
                </Tooltip>
                <Tooltip title="Upload Stock Sell">
                  <LoadingButton
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ width: "105px" }}
                    component="label"
                    loading={uploadLoader}
                    loadingPosition="start"
                    startIcon={<UploadFileIcon size="large" />}
                    disabled={(canEdit || !notPermitted) ? false : true}
                  >
                    Upload
                    <input
                      id="file-input"
                      hidden
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      multiple
                      type="file"
                      onChange={(e) => handleUpload(e.target.files[0])}
                      onClick={(e) => handleClear()}
                    />
                  </LoadingButton>
                </Tooltip>
                {stonesLoader ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <Tooltip title="Reload List">
                    <RefreshOutlinedIcon
                      onClick={() => {
                        stockData ? handleStockData(stockData) : handleSearch(stoneId.length === 0 ? listStoneIds : stoneId)
                        setSellButtonDisable(false);
                      }}
                      color="primary"
                      fontSize="large"
                      sx={{ cursor: "pointer", height: "1.8rem", width: "1.8rem" }}
                    />
                  </Tooltip>
                )}
              </Box>) : null}
            </Box>
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 1fr 1fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap={"15px"}
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Pieces"
                    disabled
                    value={listData.length}
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Carats"
                    disabled
                    value={totalCarat}
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Exchange Rate"
                    placeholder="Enter Exchange Rate"
                    value={exchangeRate}
                    onChange={(e) => handleExchangeRate(e)}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? (currency === "USD") : true}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label={
                      `Shipping Cost ` + (currency === "INR" ? "(USD)" : "")
                    }
                    placeholder="Enter Shipping Cost"
                    value={shippingCost}
                    onChange={(e) => {
                      let updatedValue = e.target.value.replace(/[^0-9.]/gi, "").replace(/^0+/g, "") || "0";
                      handleShippingCost(updatedValue)
                    }
                    }
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    // disabled={true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
                  <TextField
                    margin="normal"
                    // type="number"
                    fullWidth
                    label="Old Discount"
                    placeholder="Enter Discount"
                    value={oldTotalDiscount}
                    disabled={true}
                  />
                  <TextField
                    margin="normal"
                    // type="number"
                    fullWidth
                    label="New Discount"
                    placeholder="Enter Discount"
                    value={totalDiscount}
                    onChange={(e) => setTotalDiscount(e.target.value)}
                    onKeyDown={handleDiscount}
                    onBlur={handleDiscount}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Old Invoice Amount"
                    placeholder="Enter invoice amount"
                    value={oldTotalInvoiceAmount}
                    onChange={(e) => setInvoiceAmount(e.target.value)}
                    onKeyDown={handleInvoicee}
                    onBlur={handleInvoicee}
                    disabled={true}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="New Invoice Amount"
                    placeholder="Enter invoice amount"
                    value={invoiceAmount}
                    onChange={(e) => setInvoiceAmount(e.target.value)}
                    onKeyDown={handleInvoicee}
                    onBlur={handleInvoicee}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", gap: "10px", width: "100%", }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Old Price Per Carat Amount"
                    placeholder="Enter Price Per Carat Amount"
                    value={oldTotalPPC}
                    onChange={(e) => setAvgPricePerCarats(e.target.value)}
                    onKeyDown={handlePricePerCarat}
                    onBlur={handlePricePerCarat}
                    disabled={true}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Price Per Carat Amount"
                    placeholder="Enter Price Per Carat Amount"
                    value={avgPricePerCarats}
                    onChange={(e) => setAvgPricePerCarats(e.target.value)}
                    onKeyDown={handlePricePerCarat}
                    onBlur={handlePricePerCarat}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                {fieldPermission ? (<Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Add/Less %"
                    placeholder="Enter Add/Less Discount"
                    value={addLessPercent}
                    onChange={(e) => setAddLessPercent(e.target.value)}
                    onKeyDown={handleAddLessPercent}
                    onBlur={handleAddLessPercent}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Add/Less Amount"
                    placeholder="Enter Add/Less Amount"
                    value={addLessAmount}
                    onChange={(e) => setAddLessAmount(e.target.value)}
                    onKeyDown={handleAddLessAmount}
                    onBlur={handleAddLessAmount}
                    disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!(((fieldPermission && canEdit) || (!notPermitted)) ? false : true) && (
                            <EditIcon style={{ fontSize: '1.1rem', color: 'black', marginBottom: 4, marginRight: -3 }} />
                          )}
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>) : null}
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  {currency === "INR" && (
                    <TextField
                      label="Payable Amount (USD)"
                      id="outlined-start-adornment"
                      margin="normal"
                      disabled
                      fullWidth
                      value={(payableAmount / exchangeRate).toFixed(2)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  )}
                  <TextField
                    label={
                      `Payable Amount ` + (currency === "INR" ? "(INR)" : "")
                    }
                    id="outlined-start-adornment"
                    margin="normal"
                    disabled
                    fullWidth
                    value={payableAmount}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {currency === "USD" ? "$" : "₹"}
                        </InputAdornment>
                      ),
                    }}
                  />

                </Box>
              </Box>
            </Box>
            <Box display={"flex"} flexDirection={"row"} gap={"10px"}>
              <Box sx={{ display: "flex", width: "37%" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  multiline
                  // rows={3}
                  label="Remark"
                  placeholder="Enter Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  disabled={(canEdit) ? false : true}
                />
              </Box>
              <Box sx={{ display: "flex", width: "24.8%" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  label="Terms"
                  placeholder="Enter Terms"
                  value={terms}
                  onChange={(e) => setTerms(e.target.value)}
                  disabled={Constants.loggedInUser.usertype !== "E" ? true : (canEdit) ? false : true}
                />
              </Box>
              <Box sx={{ display: "flex", width: "11.8%" }}>
                <TextField
                  margin="normal"
                  type="number"
                  fullWidth
                  label="Days"
                  placeholder="Enter Days"
                  value={invoiceDays}
                  onKeyDown={(e) => {
                    if (e.key === "+" || e.key === "-") {
                      e.preventDefault(); // Prevent typing + or -
                    }
                  }}
                  onChange={(e) => setInvoiceDays(e.target.value > 0 ? e.target.value : 0)}
                  disabled={Constants.loggedInUser.usertype !== "E" ? true : (canEdit) ? false : true}
                />
              </Box>
              <Box sx={{ display: "flex", width: "22%", alignItems: "center", marginLeft: "16px" }} >

                <Box display={"flex"} flexDirection={"column"}>
                  <FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "6px", marginTop: "2px" }}>
                    <Typography
                      sx={{ marginBottom: "0px", alignItems: "center", width: "160px" }}
                    >
                      Exchange Currency</Typography>
                    <RadioGroup
                      row
                      name="Exchange Currency"
                      value={currency}
                      onChange={(e) => {
                        setCurrency(e.target.value);
                        setExchangeRate(1);
                      }}
                    >
                      <FormControlLabel
                        sx={{ marginBottom: "0px" }}
                        value="USD"
                        control={<Radio />}
                        label="USD"
                        disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                      />
                      <FormControlLabel
                        sx={{ marginBottom: "0px" }}
                        value="INR"
                        control={<Radio />}
                        label="INR"
                        disabled={((fieldPermission && canEdit) || (!notPermitted)) ? false : true}
                      />
                    </RadioGroup>
                  </FormControl>
                  {fieldPermission ?
                    (<FormControl sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                      <Typography
                        sx={{ marginBottom: "0px", alignItems: "center", width: "160px" }}
                      >
                        Add to Invoice</Typography>
                      <FormGroup>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>NO</Typography>
                          <AntSwitch checked={addToInvoice} onChange={() => setAddToInvoice(!addToInvoice)} inputProps={{ 'aria-label': 'ant design' }} />
                          <Typography>YES</Typography>
                        </Stack>
                      </FormGroup>
                    </FormControl>) : null}
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          {(!proformaButton && canEdit && stoneId.length === 0) || ((proformaButton && fieldPermission) || (fieldPermission && !canEdit)) ? (
            <Box>
              <FormControlLabel
                control={
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Switch
                      checked={openInvoice}
                      onChange={() => setOpenInvoice((prev) => !prev)}
                    />
                    <Typography sx={{ mt: -1 }}>
                      Open Invoice
                    </Typography>
                  </Box>
                }
                label=""
              />
            </Box>
          ) : null}
          {Utility.isAddAllowed(proforma_Permission) ||
            Utility.isUpdateAllowed(proforma_Permission) ||
            Utility.isAddAllowed(salePermission) ||
            Utility.isUpdateAllowed(salePermission) ? (
            <Box
              sx={{
                "& .Mui-disabled": {
                  backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                  color: "rgba(0, 0, 0, 0.26) !important"
                },
                //  display: 'flex', flexDirection: '', alignItems: 'center'
              }}
            >
              {proformaButton ? (
                <LoadingButton
                  variant="contained"
                  onClick={saveProforma}
                  loading={loadingProformaButton}
                  loadingPosition="start"
                  type="Submit"
                  startIcon={<FaFileInvoice />}
                  sx={{ mr: 3 }}
                  disabled={sellButtonDisable || disableAllButtons}
                >
                  {fieldPermission ? "Proforma" : "Buy"}
                </LoadingButton>
              ) : null}
              {!proformaButton && (canEdit || Utility.isUpdateAllowed(proforma_Permission)) && stoneId.length === 0 ? (
                <LoadingButton
                  variant="contained"
                  onClick={updateProforma}
                  type="Submit"
                  loading={saveloading}
                  loadingPosition="start"
                  color="success"
                  startIcon={<FaFileInvoiceDollar />}
                  sx={{ mr: 3 }}
                  disabled={sellButtonDisable || disableAllButtons}
                >
                  Save
                </LoadingButton>
              ) : null}
              {!proformaButton && canEdit && stoneId.length === 0 ? (
                <LoadingButton
                  variant="contained"
                  onClick={updateProformaToInvoice}
                  type="Submit"
                  loading={saveInvoiceLoading}
                  loadingPosition="start"
                  color="success"
                  startIcon={<FaFileInvoiceDollar />}
                  sx={{ mr: 3 }}
                  disabled={invoicePermission.length === 0 || sellButtonDisable || disableAllButtons}
                >
                  Save & Invoice
                </LoadingButton>
              ) : null}
              {(proformaButton && fieldPermission) || (fieldPermission && !canEdit) ? (
                <LoadingButton
                  variant="contained"
                  onClick={saveInvoice}
                  type="Submit"
                  loading={loading}
                  loadingPosition="start"
                  color="success"
                  startIcon={<FaFileInvoiceDollar />}
                  sx={{ mr: 3 }}
                  disabled={invoicePermission.length === 0 || sellButtonDisable || disableAllButtons}
                >
                  Invoice
                </LoadingButton>
              ) : null}
            </Box>
          ) : null}
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={disableAllButtons}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default SellMemoModal;
